import React from "react";

import { Grid } from "@material-ui/core";

import { CoveredRegion, FranchiseType } from "@hubcapp/types";

import { AreaStateProviderProps } from "./types";
import AreaSkeleton from "./components/AreaSkeleton";
import LearnerAreaCard from "./components/LearnerAreaCard";
import OtherAreaCard from "./components/OtherAreaCard";

const AreaStateProvider: React.FC<AreaStateProviderProps> = ({
  franchise,
  loading = false,
}) => {
  if (loading) {
    return <AreaSkeleton />;
  }

  const franchiseType = franchise?.proposition.type;

  return (
    <Grid container spacing={3}>
      {franchise?.coverage.filter(Boolean).map(coverage => (
        <Grid item xs={12} key={coverage?.id}>
          {franchiseType === FranchiseType.Dit ||
          franchiseType === FranchiseType.Motability ? (
            <OtherAreaCard
              coverage={coverage as CoveredRegion}
              franchise={franchise}
            />
          ) : (
            <LearnerAreaCard coverage={coverage as CoveredRegion} />
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default AreaStateProvider;
